import React, { createContext, useContext, useState, useEffect } from "react";
import { GetConfigs } from "../../services/backendServices";
import { STORAGE_KEYS } from "../../utils/key_helper";
import { encryptData, decryptData } from "../../utils/secureStorage";
// Create a context for ProfileData
const ConfigContext = createContext();
/*** ConfigContextProvider: A provider component to manage and supply profile data*/
export const ConfigContextProvider = ({ children }) => {
    const [configData, setConfigData] = useState(() => {
        const storedconfigs = localStorage.getItem(STORAGE_KEYS.CONFIGS);
        return storedconfigs ? decryptData(storedconfigs) : null;
    });
    const [bankData, setBankData] = useState(null);
    const [parentData, setParentData] = useState(null);
    const [phonePePaymentUrl, setPhonePePaymentUrl] = useState(null);



    // Function to fetch  configs data 
    const fetchConfigsData = async () => {
        try {
            const res = await GetConfigs();
            if (res.status) {
                const minimalConfigs = {
                    payment_enabled: res?.data?.config_data?.payment_enabled,
                    payment_type: res?.data?.config_data?.payment_type,
                };
                localStorage.setItem(STORAGE_KEYS.CONFIGS,
                    encryptData(minimalConfigs)
                );
                setConfigData(res?.data?.config_data);
                setPhonePePaymentUrl(res?.data?.phonepe_configs?.payment_url);
                setBankData(res?.data?.bank_details);
                setParentData(res?.data?.parent_details);
            }
        } catch (error) {
            console.error("Error fetching configs data ", error);
        }
    };
    useEffect(() => {
        const storedconfigs = localStorage.getItem(STORAGE_KEYS.CONFIGS);
        if (storedconfigs) {
            const decryptedData = decryptData(storedconfigs);
            setConfigData((prev) => ({ ...prev, ...decryptedData }));

        }
    }, []);
    useEffect(() => {
        if (!configData || !bankData) {
            fetchConfigsData();
        }

    }, [])
    return (
        // The ConfigContext.Provider component provides state and functions to the children components
        <ConfigContext.Provider
            value={{
                fetchConfigsData,
                phonePePaymentUrl,
                configData,
                bankData, parentData
            }}>
            {children}
        </ConfigContext.Provider>
    );
};

// Custom hook to use the UseConfigContext
export const useConfigContext = () => useContext(ConfigContext);
